<template>
  <div>
    <c-card
      v-for="pr in productReviews"
      :key="pr.id"
      :item="pr"
      :id="'product_review' + pr.id"
      :button-title="buttonTitle(pr.product_rating)">
      <template v-slot:header>
        <div class="dash-prdts__img-wrapper prdt-card__img-wrapper col-auto">
          <img :alt="pr.product.name" :src="pr.product.image_path || require('@/assets/images/product-placeholder.png')" class="dash-prdts__img prdt-card__img img-fluid">
        </div>
        <div class="prdt-card__details col-auto pr-0">
          <h3 class="prdt-card__name">
            {{ pr.product.name }}
            <small v-if="pr.product.stove_type" class="bg-dark text-white px-2">{{ pr.product.stove_type }}</small>
          </h3>
          <div class="text-info">
            <p class="mb-2">Créé le <span class="thin">{{ pr.formatted_created_at }}</span></p>
          </div>
        </div>
      </template>

      <div class="text-info l-spaced mb-n3" slot="body">
        <section class="mt-4">
          <h3 class="h6 mb-3">1 - Note globale</h3>
          <div class="smaller">
            <p>
              Note Bestove :
              <span class="rating-display rating-display--10stars ml-h">
                <span class="rating-display__rating rating-display--10stars__rating" :style="'width:' + pr.bestove_rating * 10 +'%;'"></span>
              </span>
            </p>
            <p>Commentaire sur Bestove : <span class="thin">{{ pr.bestove_feedback | notSpecified }}</span></p>
            <!-- <p>Commentaire anonyme : <span class="thin">Not implemented yet</span></p> -->
          </div>
        </section>
        <section>
          <h3 class="h6 mb-3">2 - Produit Bestove</h3>
          <div class="smaller">
            <p>Découvert via : <span class="thin">{{ pr.formatted_know_through }}</span></p>
            <p>
              Note du produit :
              <span class="rating-display rating-display--5stars ml-h">
                <span class="rating-display__rating rating-display--5stars__rating" :style="'width:' + pr.product_rating * 20 +'%;'"></span>
              </span>
            </p>
            <p>Commentaire sur Bestove : <span class="thin">{{ pr.product_comment | notSpecified }}</span></p>
          </div>
        </section>
        <section class="mt-4">
          <h3 class="h6 mb-3">3 - Livraison et installation</h3>
          <div class="smaller">
            <p>Installé par un professionnel : <span class="thin">{{ pr.installed_by_professional | notSpecified }}</span></p>
            <div v-for="(title, feedback) in feedbacks" :key="feedback">
              <hr />
              <p>Satisfait par {{ title }} : <span class="thin">{{ pr[`satisfied_by_${feedback}`] | notSpecified }}</span></p>
              <p v-if="pr[`positive_${feedback}_feedback`]">
                Points positifs : <span class="thin">{{ pr[`positive_${feedback}_feedback`] }}</span>
              </p>
              <p v-if="pr[`negative_${feedback}_feedback`]">
                Points négatifs : <span class="thin">{{ pr[`negative_${feedback}_feedback`] }}</span>
              </p>
            </div>
          </div>
        </section>

      </div>
    </c-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductReviews',
  data () {
    return {
      feedbacks: {
        performance: 'la prestation',
        advices: 'les conseils',
        manual: 'la notice'
      }
    }
  },
  computed: {
    ...mapGetters({ productReviews: 'bestove/productReviews' })
  },
  methods: {
    buttonTitle (rate) {
      return `Voir l'avis ${rate}/5`
    }
  }
}
</script>
